import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=34d04892&lang=less&scoped=true"

import exportComponent from "/Users/user/mscode/tecs/TECS-FE-ENDUSER-NEW/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34d04892"]])

export default __exports__